'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Record2;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _immutable = require('immutable');

var _messageTypes = require('../../pubnub-message/constants/messageTypes');

var _buildCrmObjectLifecycleUpdateMetadata = require('../operators/buildCrmObjectLifecycleUpdateMetadata');

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var CrmObjectLifecycleUpdate = function (_Record) {
  _inherits(CrmObjectLifecycleUpdate, _Record);

  function CrmObjectLifecycleUpdate() {
    var properties = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    _classCallCheck(this, CrmObjectLifecycleUpdate);

    return _possibleConstructorReturn(this, (CrmObjectLifecycleUpdate.__proto__ || Object.getPrototypeOf(CrmObjectLifecycleUpdate)).call(this, _extends({}, properties, {
      crmObjectUpdate: (0, _buildCrmObjectLifecycleUpdateMetadata.buildCrmObjectLifecycleUpdateMetadata)(properties.objectType, properties.crmObjectUpdate)
    })));
  }

  return CrmObjectLifecycleUpdate;
}((0, _immutable.Record)((_Record2 = {}, _defineProperty(_Record2, _messageTypes.MESSAGE_TYPE_ID, _messageTypes.CRM_OBJECT_LIFECYCLE_UPDATE), _defineProperty(_Record2, 'id', null), _defineProperty(_Record2, 'objectType', null), _defineProperty(_Record2, 'objectId', null), _defineProperty(_Record2, 'objectName', null), _defineProperty(_Record2, 'source', null), _defineProperty(_Record2, 'sourceId', null), _defineProperty(_Record2, 'crmObjectUpdate', null), _defineProperty(_Record2, 'timestamp', null), _Record2), 'CrmObjectLifecycleUpdate'));

exports.default = CrmObjectLifecycleUpdate;
module.exports = exports['default'];